export default __webpack_public_path__ + "static/media/russia.35fdb18a.webp";